(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-collection-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll(".accordion-item").forEach((item) => {
  item.querySelector(".accordion-header").addEventListener("click", () => {
    item.classList.toggle("open");
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
function featuredCollectionUrlBoot(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var list = scope.matches && scope.matches('[data-featured-collection-url-script]')
    ? scope
    : scope.querySelector('[data-featured-collection-url-script]');
  if (!list && document.querySelector) {
    list = document.querySelector('[data-featured-collection-url-script]');
  }
  var src = list && list.getAttribute('data-featured-collection-url-script');

  function init() {
    if (window.initFeaturedCollectionUrls) {
      window.initFeaturedCollectionUrls(root || document);
    }
  }

  if (window.initFeaturedCollectionUrls) {
    init();
    return;
  }

  if (!src) return;

  var existing = document.querySelector('script[data-featured-collection-url-loader]');
  if (existing) {
    existing.addEventListener('load', init);
    return;
  }

  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.setAttribute('data-featured-collection-url-loader', 'true');
  script.onload = init;
  document.head.appendChild(script);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    featuredCollectionUrlBoot(document);
  });
} else {
  featuredCollectionUrlBoot(document);
}

document.addEventListener('shopify:section:load', function(event) {
  featuredCollectionUrlBoot(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
